<template>
  <div class="auth-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="6">
        <el-input v-model="form.nameOrCode" size="small" placeholder="合同名称/编号" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="6">
        <el-input v-model="form.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="6" class="input-group">
        <el-input v-model="form.contractMoneyMin" size="small" placeholder="最小合同金额" @keyup.enter.native="onSearch" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        <span>~</span>
        <el-input v-model="form.contractMoneyMax" size="small" placeholder="最大合同金额" @keyup.enter.native="onSearch" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
      </el-col>
      <el-col :span="6">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>

    <div class="table-wrap">
      <div class="btn-text—flex">
        <div class="table-count">合同条数：{{ page.total }}条</div>
        <div>
          <el-badge v-if="type === 'ExamineProcessing'" style="margin:0 25px;" :value="multiSelectList.length" class="item">
            <el-button :disabled="multiSelectList.length>0?false:true" type="primary" size="small" @click="openDialog">批量审批</el-button>
          </el-badge>
        </div>
      </div>
      <el-table :data="tableData" v-loading="tableLoading" size="mini" @selection-change="handleSelectionChange">
        <el-table-column type="selection"  width="55" align="center"></el-table-column>
        <el-table-column label="合同名称" prop="name" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.name }}</p>
            <p>{{ scope.row.code }}</p>
          </template>
        </el-table-column>
        <el-table-column label="合同金额" prop="money" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.money) }}
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
      
        <el-table-column label="业务负责人" prop="businessPrincipal" align="center"></el-table-column>
        <el-table-column label="合同附件" prop="path" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="lookContract(scope.row.fileDTOList)">查看合同附件</el-button>
          </template>
          <!-- <template slot-scope="scope">
            <a class="link" href="javascript:void(0);" @click="downloadFile(scope.row.path, scope.row.fileName)" :download="scope.row.fileName">{{ scope.row.fileName }}</a>
          </template> -->
        </el-table-column>
        <el-table-column label="启动申请人" prop="startApplyUserName" align="center"></el-table-column>
        <el-table-column label="启动申请时间" prop="startApplyTime" align="center" width="150"></el-table-column>
        <el-table-column label="审批时间" prop="startAuditTime" align="center" v-if="type === 'Processing'" width="150"></el-table-column>
        <el-table-column label="审批状态" prop="startAuditStatus" align="center">
          <template slot-scope="scope">
            <p>
              {{ approveConfig.getAppointed("statusStart", scope.row.startAuditStatus, "") }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="type === 'ExamineProcessing'" type="text" size="small" @click="toAssess(scope.row.id)">审批</el-button>
            <el-button v-if="object===1&&(scope.row.startAuditStatus===2||scope.row.startAuditStatus===3)" type="text" size="small" @click="toAssess(scope.row.id)">重审</el-button>
            <el-button v-else-if="type === 'Processing'&&object===2" type="text" size="small" @click="toAssess(scope.row.id)">重审</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
    </div>
    <!-- 合同附件 -->
    <el-dialog title="查看合同附件" width="40%" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column align="center" property="date" label="合同附件">
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.fileList" :modalShow="false"></filePreview>
          </template>
        </el-table-column>
        <el-table-column align="center" property="sealType" label="盖章类型">
          <template slot-scope="scope">
            {{sealType[scope.row.sealType]}}
          </template>
        </el-table-column>
        <el-table-column align="center" property="date" label="盖章状态">
          <template slot-scope="scope">
            {{sealStatus[scope.row.sealStatus]}}
          </template>
        </el-table-column>
        <el-table-column align="center" property="name" label="合同扫描件">
          <template slot-scope="scope">
            <filePreview :fileList="scope.row.scannedCopyList" :modalShow="false"></filePreview>
            <!-- <div v-for="(item,index) in scope.row.scannedCopyList" :key="index">
              <a class="link chaochu" href="javascript:void(0);" @click="downloadFile(item.path, item.name)" :download="item.name">{{ item.name }}</a>
            </div> -->
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :title="dialogTitle" width="30%" :visible.sync="dialogTableVisible1">
      <el-form v-if="dialogTitle==='批量审批'" label-position="left" :model="assessForm" ref="assessForm" label-width="100px" class="demo-ruleform">
        <el-form-item label="审批状态" prop="status" class="block-form-item w-99">
          <el-select v-model="assessForm.status" @change="statusChange">
            <el-option label="审批通过" value=1></el-option>
            <el-option label="审批不通过" value=0></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="assessForm.status == 0" label="原因" prop="notPassReason" class="block-form-item w-99">
          <el-input type="textarea" maxlength="300" show-word-limit v-model="assessForm.notPassReason"></el-input>
        </el-form-item>
        <div style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="batchClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisible1 = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import util from "@/util/util";
import validate from "@/util/validate";
import { contractConfig } from "@/const/config/contract";
import { customConfig } from "@/const/config/custom";
import { startList ,assessStartBatch } from "@/api/approve/contract";
import { approveConfig } from "@/const/config/approve";
export default {
  props: ["type"],
  data() {
    return {
      approveConfig,
      object: "",
      form: {
        nameOrCode: "",
        customerName: "",
        contractMoneyMin: "",
        contractMoneyMax: "",
      },

      page: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },

      tableLoading: false,
      tableData: [],
      gridData:"",
      dialogTableVisible:false,
      sealType:['不盖章','公章','合同章'],
      sealStatus:['不盖章','待申请盖章','盖章审核中','盖章审核不通过','待盖章','已盖章','已作废'],
      multiSelectList:[],
      dialogTableVisible1:false,
      dialogTitle:"",
      //审批
      assessForm: {
        ids:[] ,
        status: "1",
        notPassReason: "",
        auditRemark: "",
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    lookContract(data){
      this.gridData = data;
      this.dialogTableVisible = true;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    onReset() {
      this.form = {
        nameOrCode: "",
        customerName: "",
        contractMoneyMin: "",
        contractMoneyMax: "",
      };
      this.onSearch();
    },
    onSearch() {
      if (this.form.contractMoneyMin && this.form.contractMoneyMax) {
        if (
          parseInt(this.form.contractMoneyMin) >
          parseInt(this.form.contractMoneyMax)
        ) {
          this.$message.error("最小合同金额不能大于最大合同金额");
          return;
        }
      }
      this.page.pageNum = 1;
      this.getList();
    },
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;

      queryObj.auditFlag = customConfig.Status[this.type];
      this.tableLoading = true;
      startList(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.object = res.object;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 去审批页
     * @param id 合同id
     */
    toAssess(id) {
      let router = this.$router.push({
        path: "/check/contract-start/assess",
        query: {
          id,
        },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },
    /**
     * 显示原因
     * @param reason 原因
     */
    onShowReason(reason) {
      reason = reason || "";
      this.$alert(reason, "审批不通过原因", {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },

//选择
    handleSelectionChange(val){
      this.multiSelectList = val;
    },

    //打开调整输入框
    openDialog(obj){
      this.dialogTitle = '批量审批' ;
      this.dialogTableVisible1 = true ;
      console.log("======"+obj);
    },

    //批量审批
    batchClick(){
      console.log(this.multiSelectList) ;
      var ids = []
      this.multiSelectList.forEach(element => {
        ids.push(element.id)
      });
      this.assessForm.ids = ids ;
      console.log(ids) ;
      let obj = {};
      obj.ids = ids;
      obj.isPass = parseInt(this.assessForm.status);
      obj.notPassReason = this.assessForm.notPassReason; //审批失败原因
      obj.auditRemark = this.assessForm.auditRemark;
      assessStartBatch(obj)
        .then((res) => {
            this.$message.success("审批成功");
            this.dialogTableVisible1 = false
            this.getList();
        })
        .catch((error) => {
          this.dialogTableVisible1 = false
        });
    },

    //审批状态改变
    statusChange(val) {
      this.assessForm.notPassReason = "";
    },

    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
  },
  watch: {
    type(newVal, oldVal) {},
  },
};
</script>

<style lang="scss" scoped>
.table-wrap {
  margin-top: 20px;
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-text—flex{
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>